import { Clamp } from "~/components/clamp/clamp";
import { Box, Stack, TableCell, Typography } from "@mui/material";
import { FirewatchChip } from "~/components/FirewatchRow/FirewatchChip";
import { Tag, TicketRefType } from "~/operations";
import { Format } from "~/lib/date";
import { ticketTypeIconMap } from "../../ticket/TicketPage/utils/ticketPageUtils";

type CaseTitleCellProps = {
  title: string;
  createdAt: string | undefined;
  assets: number | undefined;
  isOpen?: boolean;
  "data-testid"?: string;
  tags: Array<Tag>;
  isSmallTable?: boolean;
  ticketType?: TicketRefType;
};

export const TicketsTitleCell = ({
  createdAt,
  title,
  assets,
  tags,
  isSmallTable,
  ticketType,
  ...props
}: CaseTitleCellProps) => {
  const tagsWithCreated: Tag[] = [
    {
      __typename: "Tag",
      key: "Created",
      value: `${Format(createdAt)}`,
    },
    ...tags,
  ];

  const Icon = ticketType ? ticketTypeIconMap[ticketType] : null;

  return (
    <TableCell
      sx={isSmallTable ? { pl: "5px !important" } : {}}
      data-testid={props["data-testid"]}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {Icon && <Icon sx={{ fontSize: 16 }} />}
        <Clamp>
          <Typography
            sx={{
              fontSize: isSmallTable ? 12 : 14,
              fontWeight: isSmallTable ? 400 : 700,
              lineHeight: isSmallTable ? "40px" : "16px",
              color: "text.primary",
            }}
          >
            {title}
          </Typography>
        </Clamp>
      </Stack>
      {!isSmallTable && (
        <Box display="flex" gap={1} mt={1} flexWrap="wrap">
          {tagsWithCreated?.map((tag) => (
            <FirewatchChip key={tag.key} tag={tag} />
          ))}
        </Box>
      )}
    </TableCell>
  );
};
